import {connect} from "react-redux";
import ConversationsComponent from "../components/ConversationsComponent";
import ConversationComponent from "../components/ConversationComponent";
import Conversation from "../../_data/models/Conversation";
import {push} from "react-router-redux";
import {ConversationsRoutes} from "../../routes";
import {getCurrentUser} from "../../_helpers/utils";
import {messageByIdSelector, messagesSelector, userByIdSelector} from "../../_data/selectors";
import {readMessage} from "../middlewares";

interface Props {
    conversation: Conversation;
}

const mapStateToProps = (state, props: Props) => {
    const {conversation} = props;
    const recipientId = getCurrentUser().id != conversation.userId1 ? conversation.userId1 : conversation.userId2;
    const recipient = userByIdSelector(state, recipientId);
    const lastMessage = messageByIdSelector(state, conversation.lastMessageId);

    return {
        recipient: recipient,
        lastMessage: lastMessage
    };
};

const mapDispatchToProps = (dispatch, props: Props) => {
    const {conversation} = props;

    return {
        viewConversation: () => {
            dispatch(readMessage(conversation.id));
            dispatch(push(ConversationsRoutes.messages(conversation.id)))            
        }
    };
};

const ConversationContainer = connect(mapStateToProps, mapDispatchToProps)(ConversationComponent);
export default ConversationContainer;


// WEBPACK FOOTER //
// ./app/client/message/containers/ConversationContainer.tsx